import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useStore } from "@/context/Store";

export const VariantPicker = ({ p, onAdded, sel, setSel }) => {
  const { add } = useStore();
  const nav = useNavigate();
  const [local, setLocal] = useState({ color: p.colors?.[0] || "", size: "" });
  const s = sel || local, set = setSel || setLocal;
  const v = p.variants.find((x) => x.color === s.color && x.size === s.size);
  const stockFor = (size) => p.variants.find((x) => x.color === s.color && x.size === size)?.stock || 0;
  const go = (buy) => {
    if (!v) return toast.error("Please choose a size");
    if (v.stock < 1) return toast.error("This size is sold out");
    add(p, v, 1, buy);
    onAdded?.();
    if (buy) nav("/checkout");
  };
  return (
    <div className="space-y-5" data-testid="variant-picker">
      {p.colors.length > 0 && <div><p className="eyebrow mb-2">Colour · <span className="normal-case tracking-normal">{s.color}</span></p><div className="flex gap-2">{p.colors.map((c) => <button key={c} onClick={() => set({ ...s, color: c })} className={`px-4 py-2 text-sm border ${s.color === c ? "border-[var(--ink)] bg-[var(--ink)] text-white" : "border-[#d8cfc3]"}`} data-testid={`color-${c}`}>{c}</button>)}</div></div>}
      <div><p className="eyebrow mb-2">Size</p><div className="flex flex-wrap gap-2">{p.sizes.map((z) => { const st = stockFor(z); return <button key={z} disabled={!st} onClick={() => set({ ...s, size: z })} aria-label={`Size ${z}${st ? "" : " sold out"}`} className={`min-w-[52px] px-3 py-2.5 text-sm border ${s.size === z ? "border-[var(--ox)] bg-[var(--ox)] text-white" : "border-[#d8cfc3]"} disabled:opacity-35 disabled:line-through`} data-testid={`size-${z}`}>{z}</button>; })}</div>
        {v && <p className="text-xs mt-2 text-[var(--ox)]" data-testid="stock-note">{v.stock <= 3 ? `Only ${v.stock} left` : "In stock"}</p>}</div>
      <div className="grid grid-cols-2 gap-2"><button className="btn btn-dark" onClick={() => go(false)} disabled={!p.total_stock} data-testid="add-to-cart">{p.total_stock ? "Add to Bag" : "Sold Out"}</button><button className="btn btn-line" onClick={() => go(true)} disabled={!p.total_stock} data-testid="buy-now">Buy Now</button></div>
    </div>
  );
};
